module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_storuman-ab9384b0eb801f85cb222b93d314ae4b.png";